(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-hockey/helpers/hockey-helper.js') >= 0) return;  svs.modules.push('/components/themes/sport-hockey/helpers/hockey-helper.js'); 

(function(svs) {
  'use strict';

  var isServerSide = typeof exports === 'object';
  if (!isServerSide) {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    function abbreviatePlayerName(firstName, lastName, name) {
      return new hbs.SafeString(
        svs.utils.format.abbreviatePlayerName(firstName, lastName, name)
      );
    }

    function lineupLine(list, home, iterations) {
      var ret = '';
      var rows = iterations ? iterations : 5;

      if (!_.isArray(list)) {
        return ret;
      }

      for (var j = 0; j < rows; j++) {
        if (list[j]) {
          ret +=
            '<div class="lineup-player' +
            (home ? ' lineup-players-home' : '') +
            '"><div class="f-inverted"><span class="bold">' +
            list[j].shirtNumber +
            '.</span> ' +
            list[j].name +
            ' (' +
            list[j].position +
            ')</div>';
          ret += '</div>';
        } else {
          ret +=
            '<div class="f-inverted lineup-player' +
            (home ? ' lineup-players-home' : '') +
            '">&nbsp;</div>';
        }
      }
      return ret;
    }

    hbs.registerHelper('renderMutualsHockey', function(mutuals) {
      var ret = '';
      var home = mutuals.homeWins;
      var away = mutuals.awayWins;
      var total = home + away;
      if (total === 0) {
        return '';
      }

      ret += '<ul class="three-bars span12 spread-container">';
      ret +=
        '<li style="width:' +
        (home / total) * 100 +
        '%" class="spread three-bar three-bar-dominant">' +
        home +
        '</li>';
      ret +=
        '<li style="width:' +
        (away / total) * 100 +
        '%" class="spread three-bar">' +
        away +
        '</li>';
      ret += '</ul>';

      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('abbreviatePlayerName', abbreviatePlayerName);

    hbs.registerHelper('playerGoalAssists', function(assistList) {
      var ret = '';
      if (_.isArray(assistList)) {
        var maxLength = assistList.length > 2 ? 2 : assistList.length;

        for (var i = 0; i < maxLength; i++) {
          if (
            (assistList[i].firstName && assistList[i].lastName) ||
            assistList[i].name
          ) {
            ret +=
              '<span>' +
              svs.utils.format.abbreviatePlayerName(
                assistList[i].firstName,
                assistList[i].lastName,
                assistList[i].name
              );
            ret += i < maxLength - 1 ? ', </span>' : '</span>';
          }
        }
      }
      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('hockeyLineup', function(homeMatrix, awayMatrix) {
      var ret = '';
      var titles = [
        'Målvakter',
        '1:a femman',
        '2:a femman',
        '3:e femman',
        '4:e femman',
        'Extra spelare',
        'Extra spelare'
      ];

      var iterations =
        homeMatrix.length > awayMatrix.length
          ? homeMatrix.length
          : awayMatrix.length;

      for (var i = 0; i < iterations; i++) {
        ret += '<div class="left span12 start-five">';
        ret +=
          '<h2 class="statistics-header lineup-header">' + titles[i] + '</h2>';

        if (i === 0) {
          var goalies =
            homeMatrix[i].length > awayMatrix[i].length
              ? homeMatrix[i].length
              : awayMatrix[i].length;

          ret += '<div class="left span6">';
          ret += lineupLine(homeMatrix[i], true, goalies);
          ret += '</div><div class="left span6">';
          ret += lineupLine(awayMatrix[i], false, goalies);
          ret += '</div>';
        } else {
          ret += '<div class="left span6">';
          ret += lineupLine(homeMatrix[i], true);
          ret += '</div><div class="left span6">';
          ret += lineupLine(awayMatrix[i], false);
          ret += '</div>';
        }
        ret += '</div>';
      }

      return new hbs.SafeString(ret);
    });

    hbs.registerHelper('renderTotalSavedGoalsPercentage', function(
      collection,
      player
    ) {
      player = _.findWhere(collection, { id: player.playerId });

      if (player) {
        return new hbs.SafeString(player.value || '');
      }
      return '';
    });
  }
})(svs);

 })(window);